module.exports = __webpack_public_path__ + "static/media/25.25276532.jpg";